import {observable, computed, action, transaction} from 'mobx'
import OptionsState from './options'

export default class YoutubeState extends OptionsState {

  @observable ytCategories = {}

  @action getYouTubeFilmInfo(item, updateField, replace = false) {
    // if (! item.lang) {
    //   return alert("Please select Language of items downloaded from YouTube Data API");
    // }
    const url = `/reporting/youtube/currentVideo/${item.get('film_platform_id')}`
    this.requester.call(url).then((res) => {
      const data = res.data && res.data.data
        ? res.data.data
        : res.data
      if (!data.items || (data.items && data.items.length === 0)) {
        return this.addMessage(this.__('Nothing found!'))
      }
      this._onYTInfo(item, data.items[0], updateField, replace)
      return this.addMessage(this.__('Items have been loaded.'))
    })
    .catch(this.onRequesterError.bind(this))
  }

  // tohle bych dal spid na backend a periodicky stahoval.
  // Pak jsou YT cats normalni enum pro frontend ...
  // @action getYouTubeCategories() {
  //   const url = `films/youtube/categoriesList`
  //   this.requester.callExternalRes({url, method: 'get'}).then((response) => {
  //     this.ytCategories = response.datanevim
  //   })
  // }
  //
  // _syncCategoriesWithDB() {   // save categories as enum values to backend DB
  //   this.ytCategories.map((cat) => {
  //     var newnode = {
  //       name: {
  //         en: item.snippet.title
  //       },
  //       parent: $scope.ytcategoriesenum,
  //       value: item.id
  //     }
  //     EnumSrv.create(newnode, function(err, newEnumId) {
  //       console.log(newnode + " enum created.")
  //     })
  //   })
  // }

  _YTDurationToMinutes(duration) {
    var match = duration.match(/PT(\d+H)?(\d+M)?(\d+S)?/)

    var hours = (parseInt(match[1]) || 0)
    var minutes = (parseInt(match[2]) || 0)
    var seconds = (parseInt(match[3]) || 0)

    //return hours * 3600 + minutes * 60 + seconds;
    return Math.round(hours * 60 + minutes + seconds/60)
  }

  _onYTInfo(item, data, updateField, replace) {
    // update preview src
    this.cv.ytubePreviewSrc = data.snippet.thumbnails.default.url
    // update item
    updateField('title', data.snippet.title)
    updateField('publish_date', data.snippet.publishedAt)
    updateField('channel_id', data.snippet.channelId)
    updateField('default_audio_language', data.snippet.defaultAudioLanguage)
    if (data.snippet.categoryId) {
      updateField('yt_category', data.snippet.categoryId.toString())
    }
    if (data.contentDetails.regionRestriction) {
      const restricts = data.contentDetails.regionRestriction
      if (restricts.blocked) {
        updateField('region_restrictions_blocked', restricts.blocked.join(','))
      }
      if (restricts.allowed) {
        updateField('region_restrictions_allowed', restricts.allowed.join(','))
      }
      if (!restricts.allowed && !restricts.blocked) {
        updateField('region_restrictions_allowed', 'WW') // no resctictions - WW
      }
    } else {
      updateField('region_restrictions_allowed', 'WW') // no resctrictions - WW
    }

    if (replace) {
      this.changeAttrArrayValue('common', 'name', data.snippet.title, 'en')
      this.changeAttrArrayValue('common', 'desc', data.snippet.description, 'en')
      const duration = this._YTDurationToMinutes(data.contentDetails.duration)
      this.changeAttrArrayValue('common', 'runtime', duration)
      this.changeAttrArrayValue('youtube', 'tags', data.snippet.tags.join(','))
    }
  }

}
